<div class="spinner-holder" *ngIf="!ready">
  <app-spinner></app-spinner>
</div>

<div *ngIf="ready">
  <div *ngIf="step === 'select-offer'" >
    <h1>{{ offerSet?.heading }}</h1>
    <img [src]="pixelUrl">
    <div class="offerSet-image">
      <img [src]="offerSet?.image">
    </div >
    <div class="copy" [innerHTML]="offerSet?.body_text | trustHtml"></div>
    <div class="offers">
      <a mat-raised-button *ngFor="let offer of offerSet?.offers" class="offer" routerLink="/membership/change/offers/{{offerSet.uuid}}/{{offer.uuid}}" (click)="close()">
        <div class="offer-content">
          <span class="title">{{ offer.title }}</span>
          <span class="action-text">{{ offer.action_text }}</span>
          <span class="price">{{ (offer.price || offer.membership_product.price) / 100 | currency:'USD' }} {{ offer.period }}</span>
        </div>
      </a>
    </div>

    <div class="pwyw" *ngIf="offerSet.is_pay_what_you_want">
      <form (submit)="submitPayWhatYouWant()">
        <ng-container *ngIf="offerSet.offers.length > 0">
          Or name your amount
        </ng-container>
        <ng-container *ngIf="offerSet.offers.length == 0">
          Name your amount
        </ng-container>

        <div class="pwyw-container">
          <div class="input">
            $<input name="pwywPrice" type="number" [(ngModel)]="pwywPrice" />
          </div>
          /
          <select name="pwywPeriod" [(ngModel)]="pwywPeriod">
            <option value="monthly">month</option>
            <option value="annually">year</option>
          </select>
          <button [disabled]="!pwywValid">Continue</button>
        </div>

        <div class="rejected" *ngIf="!pwywPriceInRange && pwywPrice">
          <ng-container *ngIf="pwywPrice < 1">
            Our payment processor does not accept charges of less than $1
          </ng-container>
          <ng-container *ngIf="pwywPrice >= 1">
            To cover the costs of providing TYT membership, we can’t accept less than {{ 
              (pwywMinimum / 100) | currency: 'USD' 
            }}{{frequencySuffixForPeriod(pwywPeriod)}}
          </ng-container>
        </div>
      </form>
    </div>

    <div class="actions">
      <a mat-raised-button color="primary" (click)="close()" 
        routerLink="/settings/memberships">Keep my current membership</a>
        
      <button mat-button (click)="cancelMembershipClick()">
        {{ offerSet?.cancel_link_text || 'No thanks, let me cancel' }}
      </button>
    </div>

    <div class="abort">
    </div>

  </div>

  <div *ngIf="step === 'change-membership'">
    <tyt-change-membership-confirmation
      [phase]="'confirm'"
      [product]="selectedProduct"
      [periodChange]="periodChange"
      [user]="user"
      (errorMessageChange)="null"
      (readyChange)="ready=$event"
    >

    </tyt-change-membership-confirmation>
  </div>
</div>